import styles from "./HeroSection.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation , Autoplay} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useEffect } from "react";
import { SliderData } from "../../../../interface/site.interface";
import MainButton from "../../../shared/button/MainButton";
import { useDispatch, useSelector } from "react-redux";
import { fetchSlider } from "../../../../redux/Slices/sliderSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import Spinner from "../../../shared/spinner/Spinner";
const HeroSection = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { data, loading } = useSelector((state: any) => state.slider);
  const language = useSelector((state: RootState) => state.language.language);

  useEffect(() => {
    dispatch(fetchSlider());
  }, [dispatch, language]);

  useEffect(() => {
    if (!data?.length) return;
    const firstUrl = `https://www.colibri.az/${data[0].url}`;
    const existing = document.querySelector(`link[rel="preload"][href="${firstUrl}"]`);
    if (existing) return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = firstUrl;
    document.head.appendChild(link);
    return () => { link.remove(); };
  }, [data]);

  if (loading) {
    return (
      <div className={styles.loading_container}>
        <Spinner size="large" />
      </div>
    );
  }

  return (
    <div id={styles.hero_section}>
      <div className="container">
        <div className={styles.slider}>
          <Swiper
            className={styles.hero_swiper}
            rewind={true}
            navigation={true}
            modules={[Navigation,Autoplay]}
            slidesPerView={"auto"}
            spaceBetween={30}
            loop
            allowTouchMove={true}
            autoplay={{
              delay: 6000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              1200: {
                slidesPerView: 1,
              },
              1024: {
                slidesPerView: 1,
              },
              994: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 1,
              },
              0: {
                slidesPerView: 1,
              },
            }}
          >
            {data?.map((item: SliderData, index: number) => {
              return (
                <SwiperSlide key={index} className={styles.hero_swiperSlide}>
                  <div className={styles.hero_card_}>
                    <img
                      src={`https://www.colibri.az/${item.url}`}
                      alt=""
                      className={styles.hero_image}
                      loading="eager"
                      decoding={index === 0 ? "sync" : "async"}
                      fetchPriority={index === 0 ? "high" : "auto"}
                    />
                    {item.button_title && (
                      <MainButton
                        onClick={() => {
                          if (item.redirect)
                            window.location.href = item.redirect;
                        }}
                        className={styles.hero_button}
                        text={item.button_title!}
                      />
                    )}
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
